<script>
import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
import { projectState, syncActiveVersionFromProjectMedia } from "@app/store/projectStore.svelte.js";
import { environment } from "@app/store/envStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import { fade } from "svelte/transition";
import * as m from "@app/paraglide/messages.js";
import { ensureStems } from "@app/lib/audio/stems.js";

const stemSlots = [
    {
        kind: "background",
        icon: "bi-music-note-list",
        label: () => m.audio_stems_background_label(),
        help: () => m.audio_stems_background_help(),
    },
    {
        kind: "foreground",
        icon: "bi-chat-quote",
        label: () => m.audio_stems_foreground_label(),
        help: () => m.audio_stems_foreground_help(),
    },
];

async function selectStem(kind, changeEvent) {
    const file = changeEvent.currentTarget.files?.[0];
    changeEvent.currentTarget.value = "";
    if (!file) return;

    try {
        const localPath = environment.electron
            ? await window.webUtils.getPathForFile(file)
            : URL.createObjectURL(file);

        const stems = ensureStems(projectState.media);
        stems[kind] = { name: file.name, localPath };
        syncActiveVersionFromProjectMedia();
    } catch (err) {
        console.log(err, err.message);
        toast.push(m.audio_stems_select_failed_toast(), { classes: ["toast-danger"] });
    }
}

function clearStem(kind) {
    const stems = ensureStems(projectState.media);
    stems[kind] = { name: "", localPath: "" };
    syncActiveVersionFromProjectMedia();
}
</script>

<div transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'audioStems' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="audioStemsTitle"
    aria-describedby="audioStemsDesc"
    tabindex="-1"
    id="AudioStemsModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="audioStemsTitle">{m.audio_stems_title()}</h4>
                <button type="button"
                    class="btn-close"
                    id="btnCloseAudioStems"
                    aria-label={m.close_dialog()}
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="audioStemsDesc" class="text-muted small">{m.audio_stems_description()}</p>
                {#each stemSlots as slot (slot.kind)}
                    {@const stem = projectState.media?.stems?.[slot.kind]}
                    <div class="mb-3">
                        <label for="stemFile-{slot.kind}" class="form-label fw-bold">
                            <i class="bi {slot.icon}"></i> {slot.label()}
                        </label>
                        <div class="input-group">
                            <input
                                type="file"
                                class="form-control"
                                id="stemFile-{slot.kind}"
                                accept="audio/*,video/*"
                                onchange={(changeEvent) => selectStem(slot.kind, changeEvent)} />
                            {#if stem?.localPath}
                                <button
                                    type="button"
                                    class="btn btn-outline-danger"
                                    aria-label={m.audio_stems_clear_label()}
                                    title={m.audio_stems_clear_label()}
                                    onclick={() => clearStem(slot.kind)}>
                                    <i class="bi bi-x"></i>
                                </button>
                            {/if}
                        </div>
                        <small class="form-text text-muted">
                            {#if stem?.localPath}
                                <i class="bi bi-check-circle text-success"></i> {m.audio_stems_loaded_label({ name: stem.name || stem.localPath.split(/[\\/]/).pop() })}
                            {:else}
                                {slot.help()}
                            {/if}
                        </small>
                    </div>
                {/each}
                <button class="btn btn-primary float-end" type="button" onclick={hideModal}>{m.ok()}</button>
            </div>
        </div>
    </div>
</div>
